module.exports = __webpack_public_path__ + "static/media/next black.78b8a68a.svg";